import { render, staticRenderFns } from "./channelsLayout.vue?vue&type=template&id=bc1ac6d0&scoped=true&"
import script from "./channelsLayout.vue?vue&type=script&lang=js&"
export * from "./channelsLayout.vue?vue&type=script&lang=js&"
import style0 from "./channelsLayout.vue?vue&type=style&index=0&id=bc1ac6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ac6d0",
  null
  
)

export default component.exports